import React from 'react';
import { Box, Paper } from '@mui/material';
import loginBackground from '../assets/mainBackground.jpg'

const GlassLayout = ({ children, height = 400, width = {md:440 , xs:380} }) => {
    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
                backgroundImage: `url(${loginBackground})`,
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                    xs: 'center',
                    md: 'flex-start',
                },
                overflowX: 'hidden',
                boxSizing: 'border-box', 
                px: {
                    xs: 2,
                    md: 23,
                },
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(211,211,211, 0.10)',
                    borderRadius: 4,
                    padding: { xs: 2, md: 4 },
                    width: '100%',
                    maxWidth: width,
                    minHeight: height || 350,
                    boxSizing: 'border-box',
                    boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37)',
                    border: '1px solid rgba(211,211,211, 0.10)',
                    textAlign: 'center',
                    alignContent: 'center',
                    color:'#ffff'
                }}
            >
                {children}
            </Paper>
        </Box>
    );
};

export default GlassLayout;
